/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  window.theme = window.theme || {};
  if (!window.theme.sizeChartToggleInited) {
    window.theme.sizeChartToggleInited = true;
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-size-chart-unit]');
      if (!btn) return;
      e.preventDefault();
      var container = btn.closest('[data-size-chart-drawer-content]');
      if (!container) return;
      var unit = btn.getAttribute('data-size-chart-unit');
      var metricTable = container.querySelector('[data-size-chart-table="metric"]');
      var imperialTable = container.querySelector('[data-size-chart-table="imperial"]');
      var metricBtn = container.querySelector('[data-size-chart-unit="metric"]');
      var imperialBtn = container.querySelector('[data-size-chart-unit="imperial"]');
      if (unit === 'metric') {
        if (metricTable) metricTable.classList.remove('size-chart-table--hidden');
        if (imperialTable) imperialTable.classList.add('size-chart-table--hidden');
        if (metricBtn) { metricBtn.classList.add('is-active'); metricBtn.setAttribute('aria-pressed', 'true'); }
        if (imperialBtn) { imperialBtn.classList.remove('is-active'); imperialBtn.setAttribute('aria-pressed', 'false'); }
      } else {
        if (imperialTable) imperialTable.classList.remove('size-chart-table--hidden');
        if (metricTable) metricTable.classList.add('size-chart-table--hidden');
        if (imperialBtn) { imperialBtn.classList.add('is-active'); imperialBtn.setAttribute('aria-pressed', 'true'); }
        if (metricBtn) { metricBtn.classList.remove('is-active'); metricBtn.setAttribute('aria-pressed', 'false'); }
      }
    });

    document.addEventListener('theme:drawer:open', function () {
      document.body.classList.add('size-chart-open');
    });

    document.addEventListener('theme:drawer:close', function () {
      document.body.classList.remove('size-chart-open');
    });
  }

  function initProductCardSwiper(card) {
    if (!card || card.dataset.swiperInitialized === 'true') return;
    if (typeof window.Swiper !== 'function') return;

    var swiperRoot = card.querySelector('[data-product-card-swiper-root]');
    var wrapper = swiperRoot && swiperRoot.querySelector('.swiper-wrapper');
    var slidesTemplate = card.querySelector('template[data-product-card-swiper-slides]');
    var prevEl = card.querySelector('[data-swiper-prev]');
    var nextEl = card.querySelector('[data-swiper-next]');

    if (!swiperRoot || !wrapper || !slidesTemplate) return;

    if (slidesTemplate.content && slidesTemplate.content.childNodes.length) {
      wrapper.appendChild(slidesTemplate.content.cloneNode(true));
    } else if (slidesTemplate.innerHTML && slidesTemplate.innerHTML.trim() !== '') {
      wrapper.insertAdjacentHTML('beforeend', slidesTemplate.innerHTML);
    }

    card.dataset.swiperInitialized = 'true';

    new window.Swiper(swiperRoot, {
      loop: false,
      slidesPerView: 1,
      watchOverflow: true,
      speed: 350,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
    });
  }

  function observeProductCardSwipers() {
    var cards = document.querySelectorAll('[data-product-card-swiper]');
    if (!cards.length) return;

    if (typeof window.IntersectionObserver !== 'function') {
      for (var i = 0; i < cards.length; i++) {
        initProductCardSwiper(cards[i]);
      }
      return;
    }

    var io = new IntersectionObserver(
      function(entries) {
        for (var j = 0; j < entries.length; j++) {
          if (!entries[j].isIntersecting) continue;
          initProductCardSwiper(entries[j].target);
          io.unobserve(entries[j].target);
        }
      },
      { rootMargin: '200px 0px' }
    );

    for (var k = 0; k < cards.length; k++) {
      io.observe(cards[k]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProductCardSwipers);
  } else {
    observeProductCardSwipers();
  }

  window.addEventListener('load', observeProductCardSwipers, { once: true });

  // Sort dropdown toggle on collection pages.
  // Replaces the orphaned customisation that used to live at the bottom of
  // assets/theme.js so the storefront can ship the minified theme.js again.
  if (!customElements.get('collection-sort')) {
    class CollectionSort extends HTMLElement {
      constructor() {
        super();
        this._onLabelClick = this._onLabelClick.bind(this);
        this._onDocumentClick = this._onDocumentClick.bind(this);
      }

      connectedCallback() {
        this.label = this.querySelector('.collection__sort__label');
        this.wrapper = this.querySelector('.collection__sort__option-wrapper');
        if (!this.label || !this.wrapper) return;

        this.label.addEventListener('click', this._onLabelClick);
        document.addEventListener('click', this._onDocumentClick);
      }

      disconnectedCallback() {
        if (this.label) this.label.removeEventListener('click', this._onLabelClick);
        document.removeEventListener('click', this._onDocumentClick);
      }

      _onLabelClick(event) {
        event.stopPropagation();
        this.wrapper.classList.toggle('collection__sort__option-wrapper--visible');
      }

      _onDocumentClick(event) {
        if (!this.wrapper.classList.contains('collection__sort__option-wrapper--visible')) return;
        if (this.contains(event.target)) return;
        this.wrapper.classList.remove('collection__sort__option-wrapper--visible');
      }
    }

    customElements.define('collection-sort', CollectionSort);
  }

  // Circle-text rotate-on-scroll for product pages.
  // Palo Alto only registers parallaxSection on `overlapping-images` and
  // `products-list`, so the [data-parallax="circle"] elements rendered inside
  // product-template / featured-product sections need their own scroll handler.
  // Mirrors theme.js → ParallaxElement.animateCircleText().
  function initProductPageCircleParallax() {
    var hosts = document.querySelectorAll(
      '[data-section-type="product-template"] [data-parallax="circle"], ' +
      '[data-section-type="featured-product"] [data-parallax="circle"]'
    );
    if (!hosts.length) return;

    var elements = [];
    for (var i = 0; i < hosts.length; i++) {
      elements.push({ el: hosts[i], height: hosts[i].offsetHeight });
    }

    var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    var ticking = false;

    function update() {
      ticking = false;
      var scrollTop = Math.round(window.scrollY);
      var scrollBottom = scrollTop + viewportHeight;

      for (var i = 0; i < elements.length; i++) {
        var entry = elements[i];
        if (entry.el.classList.contains('is-disabled')) continue;

        var rect = entry.el.getBoundingClientRect();
        var elementOffsetTop = Math.round(rect.top + scrollTop);
        var elementOffsetBottom = elementOffsetTop + entry.height;
        if (elementOffsetBottom < scrollTop || elementOffsetTop > scrollBottom) continue;

        var scrollProgress = scrollBottom - elementOffsetTop - entry.height / 2;
        var percentage = Number(((scrollProgress * 100) / viewportHeight).toFixed(2));
        if (percentage <= 0) continue;

        var rotateDegree = 70;
        var angle = ((rotateDegree * percentage) / 100) * -1;
        var adjustRotateDegree = rotateDegree / 2;
        entry.el.style.setProperty('--rotate', (adjustRotateDegree + angle) + 'deg');
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function onResize() {
      viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      for (var i = 0; i < elements.length; i++) {
        elements[i].height = elements[i].el.offsetHeight;
      }
      update();
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPageCircleParallax);
  } else {
    initProductPageCircleParallax();
  }

  // For ID locale, swap the JS money format to the no-decimals variant so all
  // client-side variant price updates (formatMoney calls) never output ,00.
  if (window.theme && window.theme.isIDLocale) {
    var _rpl = function(s) {
      return s ? s.replace('amount_with_comma_separator', 'amount_no_decimals_with_comma_separator') : s;
    };
    window.theme.moneyFormat = _rpl(window.theme.moneyFormat);
    window.theme.moneyWithCurrencyFormat = _rpl(window.theme.moneyWithCurrencyFormat);
  }

  // Freeze page scroll on mobile when the filter drawer is open.
  // Uses position:fixed technique so it also works on iOS Safari.
  (function () {
    var _scrollY = 0;
    var _locked = false;

    function lockBodyScroll() {
      if (_locked) return;
      _locked = true;
      _scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + _scrollY + 'px';
      document.body.style.width = '100%';
    }

    function unlockBodyScroll() {
      if (!_locked) return;
      _locked = false;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, _scrollY);
    }

    function initFilterScrollLock() {
      var filtersEl = document.querySelector('[data-collection-filters]');
      if (!filtersEl) return;

      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName !== 'class') continue;
          var isOpen = filtersEl.classList.contains('collection__filters--visible');
          if (window.innerWidth < 768) {
            isOpen ? lockBodyScroll() : unlockBodyScroll();
            document.body.classList.toggle('js-filter-open', isOpen);
          } else {
            unlockBodyScroll();
          }
        }
      }).observe(filtersEl, { attributes: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFilterScrollLock);
    } else {
      initFilterScrollLock();
    }
  }());

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();